import React from 'react';

import { createComponent, Layout, Input, Checkbox, Button, enums, Header, Animate } from 'console-kit';
import { connect } from 'react-redux';

import AuthPanelSelectors from '../../redux/selectors';
import AuthPanelActions from '../../redux/actions';
import authStatics from '../../../../common/static';
import AuthImageLogo from '../../../../components/AuthImageLogo';

import _enums from '../../../../common/enums';

const AuthPanelForm = createComponent({
  displayName:  'AuthPanelForm',
  propTypes:    {},
  defaultProps: {},
  refs:         'authPanelRef',
  state:        {
    authFormValidation: {
      value: {
        passwordValid:        true,
        passwordErrorMessage: undefined,

        nameErrorMessage: undefined,
        nameValid:        true,
      },
      updater: 'setAuthFormValidation',
    },
  },
  handlers: {
    handleValueChange: p => (e, { id, value }) => {
      p.onUpdateField({ fieldId: id, value });
    },

    handleContinueClick: p => (e, { id, value }) => {
      e.preventDefault();
      p.onContinueClick();
    },

    handleCheckboxClick: p => (e, { id }) => {
      p.onUpdateField({ fieldId: 'rememberMeFieldValue', value: !p.rememberMeFieldValue });
    },

    handleClick: props => (e, { value }) => {
      e.preventDefault();
      props.setAuthFormValidation({
        passwordValid:        !!props.passwordFieldValue,
        passwordErrorMessage: !!props.passwordFieldValue ? '' : 'This field is required.',

        nameErrorMessage: !!props.userFieldValue ? '' : 'This field is required.',
        nameValid:        !!props.userFieldValue,
      });
      const isValid = !!(props.userFieldValue && props.passwordFieldValue);
      props.onLoginClick(props.refs.authPanelRef, isValid);
    },
  },
  render(props) {
    return (
      <div className={authStatics.SCREEN_CLASSES}>
        <form ref={props.setAuthPanelRef} action={authStatics.AUTH_FORM_SUBMIT_URL}>
          <input type="hidden" name={props.rememberMeFieldName} value={!!props.rememberMeFieldValue} />
          <Layout>
            <Layout.Row>
              <Layout.Column textAlign={enums.textAlignments.CENTER}>
                <AuthImageLogo />
              </Layout.Column>
            </Layout.Row>

            <Layout.Row>
              <Layout.Column textAlign={enums.textAlignments.LEFT}>
                <Header
                  text="Login to Marigold Grow"
                  isDividing={false}
                  font={{
                    emphasis: enums.font.emphasis.NORMAL,
                  }}
                  size={enums.sizes.X6}
                />
              </Layout.Column>
            </Layout.Row>

            <Layout.Row>
              <Layout.Column>
                <Input
                  hasError={!props.authFormValidation.nameValid}
                  errorMessage={props.authFormValidation.nameErrorMessage}
                  label="Username"
                  isFluid={true}
                  placeholder=""
                  type="email"
                  id="userFieldValue"
                  name={props.userFieldName}
                  isUnderlined={false}
                  onChange={props.handleValueChange}
                  value={props.userFieldValue}
                />
              </Layout.Column>
            </Layout.Row>

            <Choose>
              {/*If we do not have an empty login type, that means we have already identified the email and it should be either a FORM2FA login type OR a FORM type login. This means we no longer need to display the continue button, but instead we show the login button and an expanded form for the user to work with.*/}
              <When condition={props.loginType !== _enums.loginTypes.NONE}>
                <Layout>
                  <Layout.Row>
                    <Layout.Column>
                      <Input
                        hasError={!props.authFormValidation.passwordValid}
                        errorMessage={props.authFormValidation.passwordErrorMessage}
                        label="Password"
                        isFluid={true}
                        placeholder=""
                        type="password"
                        id="passwordFieldValue"
                        name={props.passwordFieldName}
                        onChange={props.handleValueChange}
                        value={props.passwordFieldValue}
                      />
                    </Layout.Column>
                  </Layout.Row>

                  <If condition={props.loginType === _enums.loginTypes.TYPE_FORM2FA}>
                    <Layout.Row>
                      <Layout.Column>
                        <Input
                          hasError={false}
                          label="Code"
                          isFluid={true}
                          placeholder=""
                          type="text"
                          id="totpCodeFieldValue"
                          name={props.totpCodeFieldName}
                          onChange={props.handleValueChange}
                          value={props.totpCodeFieldValue}
                          autoComplete="off"
                        />
                      </Layout.Column>
                    </Layout.Row>
                  </If>

                  <Layout.Row>
                    <Layout.Column>
                      <Checkbox
                        label="Remember me for 14 days"
                        value="rememberMe"
                        onChange={props.handleCheckboxClick}
                        isChecked={!!props.rememberMeFieldValue}
                        isCompact
                      />
                    </Layout.Column>
                  </Layout.Row>

                  <Layout.Row>
                    <Layout.Column textAlign={enums.textAlignments.CENTER}>
                      <a href="#" onClick={props.onForgetPasswordClick}>
                        Forgot your password?
                      </a>
                    </Layout.Column>
                  </Layout.Row>

                  <Layout.Row>
                    <Button.WithAnimation
                      actions={{
                        start:   AuthPanelActions.onLoginRequest,
                        success: AuthPanelActions.onLoginRequestSuccess, //no action
                        failure: AuthPanelActions.onLoginRequestFailure, //no action
                      }}
                    >
                      <Button.Primary
                        text="Sign In"
                        size={enums.sizes.X4}
                        onClick={props.handleClick}
                        textAlign={enums.textAlignments.CENTER}
                        color={enums.colors.ACCENT}
                        isSolid
                        isFluid
                      />
                    </Button.WithAnimation>
                  </Layout.Row>
                </Layout>
              </When>

              {/*If we are not logged in yet, this means we should show a continue button to submit the email verification first. Once we are identified we will get a login type which means we can handle it later in the process*/}
              <When condition={props.loginType === _enums.loginTypes.NONE}>
                <Layout.Row>
                  <Button.WithAnimation
                    actions={{
                      start:   AuthPanelActions.onEmailSubmitRequest,
                      success: AuthPanelActions.onEmailSubmitRequestSuccess, //no action
                      failure: AuthPanelActions.onEmailSubmitRequestFailure, //no action
                    }}
                  >
                    <Button.Primary
                      text="Continue"
                      size={enums.sizes.X4}
                      onClick={props.handleContinueClick}
                      textAlign={enums.textAlignments.CENTER}
                      color={enums.colors.ACCENT}
                      isSolid
                      isFluid
                    />
                  </Button.WithAnimation>
                </Layout.Row>
              </When>
            </Choose>
          </Layout>
        </form>
      </div>
    );
  },
});

export default connect(
  state => {
    return {
      passwordFieldValue: AuthPanelSelectors.passwordFieldValue(state),
      passwordFieldName:  AuthPanelSelectors.passwordFieldName(state),

      userFieldValue: AuthPanelSelectors.userFieldValue(state),
      userFieldName:  AuthPanelSelectors.userFieldName(state),

      totpCodeFieldValue: AuthPanelSelectors.totpCodeFieldValue(state),
      totpCodeFieldName:  AuthPanelSelectors.totpCodeFieldName(state),

      rememberMeFieldValue: AuthPanelSelectors.rememberMeFieldValue(state),
      rememberMeFieldName:  AuthPanelSelectors.rememberMeFieldName(state),

      loginType: AuthPanelSelectors.loginType(state),
    };
  },
  dispatch => ({
    onUpdateField({ fieldId, value }) {
      dispatch(AuthPanelActions.updateField(fieldId, value));
    },

    onForgetPasswordClick() {
      dispatch(AuthPanelActions.forgetPasswordRedirect());
    },

    onLoginClick(formRef, isValid) {
      dispatch(AuthPanelActions.onLoginRequest(formRef, isValid));
    },

    onContinueClick() {
      dispatch(AuthPanelActions.onEmailSubmitRequest());
    },
  })
)(AuthPanelForm);
